import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_caret",
  "use": "svg_caret-usage",
  "viewBox": "0 0 14 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 8\" id=\"svg_caret\"><path d=\"M7.003 7.637.337.97.944.363l6.06 6.06 6.059-6.06.607.607-6.667 6.667Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol